import React from "react";
import { TertiaryIcons } from "./Tertiary";
import { StandAloneIcons } from "./Stand-Alone";
import { FormIcons } from "./Form";
import { BadgeIcons } from "./Badge";
import { MediaIcons } from "./Media";
import { PlatformIcons } from "./Platform";
import { SelectorIcons } from "./Selector";
import { IndicatorIcons } from "./Indicator";
export const Icon = ({
  badge = false,
  form = false,
  media = false,
  platform = false,
  selector = false,
  tertiary = false,
  indicator = false,
  name,
  ...props
}) => {
  var type;
  badge ? type = BadgeIcons : form ? type = FormIcons : media ? type = MediaIcons : platform ? type = PlatformIcons : selector ? type = SelectorIcons : tertiary ? type = TertiaryIcons : indicator ? type = IndicatorIcons : type = StandAloneIcons;
  const IconName = type[name];
  return IconName ? React.createElement(IconName, props) : null;
};